export default (state, action) => {
  return Object.assign({}, state, {
    request: action.request,
    loading: true,
  });
};
